export default "__VITE_ASSET__7ad50602__"